import { render } from "./SupportTickets.vue?vue&type=template&id=79dce3a1&scoped=true"
import script from "./SupportTickets.vue?vue&type=script&lang=js"
export * from "./SupportTickets.vue?vue&type=script&lang=js"

import "./SupportTickets.vue?vue&type=style&index=0&id=79dce3a1&scoped=true&lang=css"
import "./SupportTickets.vue?vue&type=style&index=1&id=79dce3a1&lang=css"

import exportComponent from "/home/forge/hike.marketing/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79dce3a1"]])

export default __exports__